/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Chinese (Traditional)
export default {
  'fabric.editor.chromeCollapsedPlaceholder': '輸入一些內容...',
  'fabric.editor.editorAssistiveLabel': '主要內容區域，打字即可輸入文字。',
  'fabric.editor.headingLink.toolbarHelpTitle': '開啟說明對話方塊',
};
